<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout row>
        <v-flex xs12>
            <v-card xs12 :disabled="controls.saving">
                <v-toolbar flat>
                    <v-toolbar-title>Billing (Left to Right)</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" small outlined text tile>Historical bills</v-btn>
                    <ExportInvoices>
                        <template v-slot:activator="{on}">
                            <v-btn v-on="on" color="secondary" small outlined text tile>Prepare Export</v-btn>
                        </template>
                    </ExportInvoices>
                    <v-btn color="secondary" small outlined text tile @click="controls.showUploadARDialog = true">Import A/R</v-btn>
                    <GlobalDiscounts>
                    </GlobalDiscounts>
                    <v-spacer></v-spacer>
                </v-card-actions>
                <v-card-text>
                    <v-layout justify-space-around>
                        <v-flex xs3>
                            <v-card tile flat outlined>
                                <v-card-text >
                                    <v-layout justify-center>
                                        <v-flex xs5>
                                            <div class="title">Customers</div>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-text>

                                    <v-data-table
                                            :headers="controls.customersHeaders"
                                            :items="customersWithUnbilledSamples"
                                            item-key="name"
                                            :expanded.sync="controls.expandedTableItems"
                                            show-expand
                                            :search="controls.searchCustomer"
                                    >
                                        <template v-slot:top>
                                            <v-text-field
                                                    v-model="controls.searchCustomer"
                                                    append-icon="search"
                                                    label="Search"
                                                    single-line
                                                    dense
                                                    hide-details
                                            ></v-text-field>
                                        </template>
                                        <template v-slot:item="{ item, isExpanded, expand }">
                                            <template v-if="controls.showAllCustomers">
                                                <tr>
                                                    <td>{{item.name}}</td>
                                                    <td>{{item.samples ? item.samples.length : 0}}</td>
                                                    <td>
                                                        <v-btn @click="isExpanded = !isExpanded" :disabled="!item.samples" icon><v-icon>{{isExpanded ? "keyboard_arrow_up" :"keyboard_arrow_down"}}</v-icon></v-btn>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr v-if="item.samples">
                                                    <td>{{item.name}}</td>
                                                    <td>{{item.samples.length}}</td>
                                                    <td>
                                                        <v-btn @click="expand(!isExpanded)"  icon><v-icon>{{isExpanded ? "keyboard_arrow_up" :"keyboard_arrow_down"}}</v-icon></v-btn>
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                        <template v-slot:expanded-item="{ headers, item }">
                                            <td :colspan="headers.length">
                                                <v-list dense>
                                                    <template v-for="(sample, index) in item.samples">
                                                        <v-list-item class="grey lighten-4" :key="sample.id">
                                                            <v-list-item-content>
                                                                <v-list-item-title>{{sample.id}}</v-list-item-title>
                                                                <v-list-item-subtitle>QA: {{sample.qa}}</v-list-item-subtitle>
                                                            </v-list-item-content>
                                                            <Confirm message="This will mark the sample as billing approved, removing it from this list." @confirmed="approveBilling(sample.id)">
                                                              <template v-slot:activator="{on:dialog}">
                                                                <v-tooltip bottom>
                                                                  <template v-slot:activator="{on:tooltip}">
                                                                    <v-btn v-on="{...tooltip, ...dialog}" color="orange darken-2" outlined small icon><v-icon>close</v-icon></v-btn>
                                                                  </template>
                                                                  <span>Remove sample from billing</span>
                                                                </v-tooltip>
                                                              </template>
                                                            </Confirm>
                                                            <v-list-item-action>
                                                                <v-btn color="success" @click="addSampleToBill(sample)" :disabled="form.bill.some(v => sample.id === v.id)" outlined small icon>
                                                                    <v-icon>arrow_forward</v-icon>
                                                                </v-btn>
                                                            </v-list-item-action>
                                                        </v-list-item>
                                                        <v-divider class="grey lighten-1" :key="index"></v-divider>
                                                    </template>
                                                </v-list>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs9>
                            <v-card tile flat outlined :disabled="controls.saving" :loading="controls.saving">
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <div class="title text-center">Bill{{billTotal ? " Total: $"+billTotal : ''}} - Volume Discount: ${{totalVolumeDiscount}}</div>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-data-table
                                        :headers="controls.billHeaders"
                                        :items="form.bill"
                                        item-key="name"
                                        show-expand
                                        disable-pagination
                                        hide-default-footer
                                    >
                                        <template v-slot:top>
                                            <v-card-text>
                                                <v-row>
                                                    <v-autocomplete
                                                            v-model="form.selectedCustomer"
                                                            :items="$store.$db().model('names').all()"
                                                            label="Select Customer"
                                                            item-text="name"
                                                            return-object
                                                            clearable
                                                            dense
                                                            @change="getBillingInfo"
                                                    >
                                                    </v-autocomplete>
                                                </v-row>
                                                <v-row v-if="prevBillStats" justify="space-around">
                                                    <v-chip label>Discount: {{prevBillStats.discount}}%</v-chip>
                                                    <v-chip label>Bill Overdue: ${{prevBillStats.ar_total - prevBillStats.ar_current}}</v-chip>
                                                    <v-chip label>AR Current: ${{prevBillStats.ar_current}}</v-chip>
                                                    <v-chip label>AR Total: ${{prevBillStats.ar_total}}</v-chip>
                                                    <v-chip label>AR Date: {{prevBillStats.ar_date ? prevBillStats.ar_date : "N/A"}}</v-chip>
                                                </v-row>
                                            </v-card-text>
                                        </template>
                                        <template v-slot:item.remove="{item}">
                                            <v-btn color="error" @click="removeSampleFromBill(item)" icon small outlined><v-icon>remove</v-icon></v-btn>
                                        </template>
                                        <template v-slot:item.required_tests="{item}">
                                          <td>{{item.sample.sample_tests.filter(test => !test.retest).map(test => test.test_type.name).join(',')}}</td>
                                        </template>
                                        <template v-slot:item.qty="{item}">
                                            <v-edit-dialog
                                                    :return-value.sync="item.qty"
                                            >
                                                {{item.qty}}
                                                <template v-slot:input>
                                                    <v-text-field
                                                            v-model="item.qty"
                                                            label="qty"
                                                    >
                                                    </v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </template>
                                        <template v-slot:item.package="{item}">
                                            <v-edit-dialog
                                                    :return-value.sync="item.package"
                                                    large
                                            >
                                                {{item.package ? item.package : "Not selected"}}
                                                <template v-slot:input>
                                                    <PackageDropdown @selected="item.package = $event"></PackageDropdown>
                                                </template>
                                            </v-edit-dialog>
                                        </template>
                                        <template v-slot:item.total="{item}">
                                            <v-edit-dialog
                                                    :return-value.sync="item.total"
                                                    large
                                            >
                                                ${{item.total}}
                                                <template v-slot:input>
                                                    <v-text-field
                                                            v-model="item.total"
                                                            label="Total"
                                                    >
                                                    </v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </template>
                                      <template v-slot:item.notes="{item}">
                                        <SampleNotes :bill="item">
                                          <template v-slot:activator="{on}">
                                            <v-btn v-on="on" tile small>Notes</v-btn>
                                          </template>
                                        </SampleNotes>
                                      </template>
                                        <template v-slot:expanded-item="{item, headers}">
                                            <td :colspan="headers.length" class="ma-0 pa-0">
                                                <v-card outlined>
                                                    <v-card-text>
                                                        <template v-for="(test, index) in item.bill.testPrices">
                                                            <v-row :key="index" justify="center">
                                                                <v-col cols="3" class="">
                                                                    <div class="subtitle-2">{{test.typeDesc}}</div>
                                                                    <div class="subtitle" v-if="test.detailedDiscount && test.discountApply">{{test.detailedDiscount}}</div>
                                                                </v-col>
                                                                <v-col cols="3">
                                                                    <div class="subtitle-2 text-right">${{test.price}}</div>
                                                                    <div class="subtitle text-right" v-if="test.detailedDiscount && test.discountApply">-${{test.groupedDiscount}}</div>
                                                                </v-col>
                                                            </v-row>
                                                        </template>
                                                        <v-divider class="black"></v-divider>
                                                        <v-row justify="center">
                                                            <v-col cols="3">Base total</v-col>
                                                            <v-col cols="3" class="text-right">${{item.bill.baseCost}}</v-col>
                                                        </v-row>
                                                        <v-row justify="center" v-if="item.bill.testCount > 0">
                                                            <v-col cols="3">Bundle Discount ({{item.bill.testCount}} tests)</v-col>
                                                            <v-col cols="3" class="text-right">-${{item.bill.discount}}</v-col>
                                                        </v-row>
                                                      <v-row justify="center" v-if="item.bill.promotional">
                                                        <v-col cols="3">Promo ({{item.bill.promotional.name}})</v-col>
                                                        <v-col cols="3" class="text-right">-${{item.bill.promotional.discount}}</v-col>
                                                      </v-row>
                                                      <v-row justify="center" v-if="item.bill.additions" v-for="add in item.bill.additions">
                                                        <v-col cols="3">Add ({{add.name}})</v-col>
                                                        <v-col cols="3" class="text-right">+${{add.price}}</v-col>
                                                      </v-row>
                                                      <v-row justify="center" v-if="item.bill.customDiscount.total > 0">
                                                        <v-col cols="3">Custom Discount ({{item.bill.customDiscount.percent}} %)</v-col>
                                                        <v-col cols="3" class="text-right">-${{item.bill.customDiscount.total}}</v-col>
                                                      </v-row>
                                                        <v-divider class="black"></v-divider>
                                                        <v-row justify="center">
                                                            <v-col cols="3">Final Total</v-col>
                                                            <v-col cols="3" class="text-right">${{item.bill.totalCost}}</v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </td>
                                        </template>
                                        <template slot="no-data">
                                            <v-btn color="success"  class="mr-2" @click="controls.showAddBillDialog = !controls.showAddBillDialog" outlined icon small><v-icon>add</v-icon></v-btn> <strong>- Create Custom billing item</strong>
                                        </template>
                                        <template v-slot:footer v-if="form.bill.length > 0">
                                            <v-divider></v-divider>
                                            <v-card-actions class="text-center">
                                                <v-btn @click="submitBill" color="success" tile depressed>Submit Invoice</v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn color="success"  class="mr-2" @click="controls.showAddBillDialog = !controls.showAddBillDialog" outlined icon small><v-icon>add</v-icon></v-btn> - Create Custom billing item
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </template>
                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                          <template v-if="form.selectedCustomer">
                            <Notes :customer_id="form.selectedCustomer.customer_id" :title="form.selectedCustomer.name"></Notes>
                          </template>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-dialog max-width="600" v-model="controls.showAddBillDialog" persistent>
                <v-card outlined>
                    <v-card-title class="title">Custom billing item</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-2">
                        <v-text-field
                                v-model="form.customBill.name"
                                label="name"
                                filled outlined
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="form.customBill.info"
                                label="info"
                                filled outlined
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="form.customBill.qty"
                                label="qty"
                                filled outlined
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="form.customBill.rate"
                                label="rate"
                                filled outlined
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="form.customBill.total"
                                label="total"
                                filled outlined
                        >
                        </v-text-field>
                        <v-text-field
                                v-model="form.customBill.notes"
                                label="notes"
                                filled outlined
                        >
                        </v-text-field>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn
                                @click="controls.showAddBillDialog = !controls.showAddBillDialog"
                                outlined
                        >
                            Close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                @click="addCustomBill"
                                color="success"
                                outlined
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog max-width="600" v-model="controls.showUploadIncomeDialog" persistent>
                <v-card>
                    <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                                color="red"
                                text
                                @click="controls.showUploadIncomeDialog = false"
                        >
                            Cancel
                        </v-btn>
                    </v-card-title>
                        <UploadIncome></UploadIncome>
                </v-card>
            </v-dialog>
            <v-dialog max-width="600" v-model="controls.showUploadARDialog" persistent>
                <v-card>
                    <v-card-title
                            class="headline grey lighten-2"
                            primary-title
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                                color="red"
                                text
                                @click="controls.showUploadARDialog = false"
                        >
                            Cancel
                        </v-btn>
                    </v-card-title>
                    <UploadAr></UploadAr>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
    import SampleBill from '../../Lib/Billing/SampleBill';
    export default {
        name: "Billing",
        components: {
            UploadAr: () => import("../../components/UploadAr"),
            UploadIncome: () => import("../../components/UploadIncome"),
            PackageDropdown: () => import("./components/PackageDropdown"),
            ExportInvoices: () => import("./components/ExportInvoices"),
            GlobalDiscounts: () => import("@/views/billing_v1/components/GlobalDiscounts"),
            Notes: () => import('@/views/DirectoryV2/components/Notes'),
            SampleNotes: () => import("@/views/billing_v1/components/SampleNotes")
        },
        data(){
            return {
                controls:{
                    loading: false,
                    saving: false,
                    showAddBillDialog: false,
                    showUploadIncomeDialog: false,
                    showUploadARDialog: false,
                    showAllCustomers: false,
                    searchCustomer: null,
                    expandedTableItems: [],
                    customersHeaders: [
                        {text: "Name", value: 'name'},
                        {text:"Sample(s)", value: "samples.length"},
                        { text: '', value: 'data-table-expand' },
                    ],
                    billHeaders:[
                        {text: "", sortable:false, value: 'remove'},
                        {text: "Name", value: 'name'},
                        {text:"Info", value: "info"},
                        {text:"tests", value: "required_tests"},
                        {text:"Type", value: "type"},
                        {text:"Package", value: "package"},
                        {text:"Total", value: "total"},
                        {text:"Notes", value: "notes"},
                        { text: '', value: 'data-table-expand' },
                    ]
                },
                loadingAddress: false,
                form:{
                    selectedAddress: null,
                    selectedCustomer: null,
                  bill: [],
                    customBill:{
                        name: null,
                        info: null,
                        qty: null,
                        rate: null,
                        total: null,
                        notes: null,
                        sample: null,
                    }
                },
                queried:{
                  customers:[]
                }
            }
        },
        mounted(){
          this.getCustomers();
          this.$store.$db().model('names').api().fetch()
        },
        computed:{
            prevBillStats(){
                if(!this.form.selectedCustomer){
                  return false;
                }
                return this.$store.$db().model('billings').query().where('customer_id', this.form.selectedCustomer.customer_id).orderBy('ar_date', 'desc').first()
            },
            billTotal(){
                return this.form.bill.length > 0
                    ? this.form.bill.reduce((a,b) => {
                            if((a && b)){
                                return parseInt(a) + parseInt(b.total)
                            }else{
                                return parseInt(b.total);
                            }
                        }, 0)
                    : 0
            },
            totalVolumeDiscount(){
                return this.form.bill.length > 0
                    ? this.form.bill.reduce((a,b) => {
                        if(a && b){
                          if(!b.bill.customDiscount) return parseInt(a);
                          return parseInt(a) + parseInt(b.bill.customDiscount.total);
                        }else{
                          if(!b.bill.customDiscount) return parseInt(b);
                          return parseInt(b.bill.customDiscount.total)
                        }
                      }, 0)
                    : 0
            },
            customersWithUnbilledSamples(){
                return this.$store.$db().model('customers').query().whereHas('samples', (subquery) => subquery.where('billing_approved', false)).with(['samples.sample_tests.test_type', 'samples.sample_type', 'samples.sample_cert_type', 'samples.sample_notes.note_type']).get().map(customer => {
                    return {
                        name: customer.primary_name.name,
                        customer_id: customer.id,
                        samples: customer.samples.filter(sample => !sample.billing_approved),
                    }
                })
            }
        },
        methods:{
            async getCustomers(){
                this.controls.loading = true;
                this.$store.$db().model('customers').deleteAll();
                this.$store.$db().model('names').deleteAll();
                this.$store.$db().model('contacts').deleteAll();
                this.$store.$db().model('samples').deleteAll();
                this.$store.$db().model('sampleTests').deleteAll();
                // this.$store.$db().model('sampleTypes').deleteAll();
                // this.$store.$db().model('sampleCertTypes').deleteAll();
                this.$store.$db().model('sampleNotes').deleteAll();
                await this.$store.$db().model('customers').api().fetch({
                    with: 'primaryName,contract'
                });
                await this.getSamples();
                this.controls.loading = false;
            },
            async getSamples(){
                await this.$store.$db().model('samples').api().fetch({
                    with: 'sampleTests,sampleType,sampleCertType,sampleNotes',
                    where: [
                      {
                        key: 'billing_approved',
                        value: false
                      },
                      {
                        key: "manifest_id",
                        condition: "!=",
                        value: "ConAn 2 Transfer Sample"
                      }
                    ]
                });
            },
            addCustomBill(){
                this.form.bill.push({
                    name: this.form.customBill.name,
                    info: this.form.customBill.info,
                    qty: this.form.customBill.qty,
                    rate: this.form.customBill.rate,
                    total: this.form.customBill.total,
                    notes: this.form.customBill.notes,
                    sample: this.form.customBill.sample,
                })
            },
            async addSampleToBill(sample){
                if(this.form.bill.length < 2 && !this.form.selectedCustomer){
                  this.form.selectedCustomer = this.$store.$db().model('names').query().where('customer_id', sample.customer_id).first()
                  await this.getBillingInfo();
                }
                let isTWC = this.$store.$db().model('imperatives').query().where('customer_id', this.form.selectedCustomer.customer_id).whereHas('imperative_type', (query) => {
                  query.where(item => item.desc.includes('TWC'));
                }).exists();
                let isPC = this.$store.$db().model('imperatives').query().where('customer_id', this.form.selectedCustomer.customer_id).whereHas('imperative_type', (query) => {
                  query.where(item => item.desc.includes('Conscious'));
                }).exists();
                let promo = isTWC ? "TWC"
                    : isPC ? "PC"
                        : null
                let bill = new SampleBill(sample.sample_tests.filter(test => !test.retest), sample.sample_cert_type.billing_category, promo, this.prevBillStats).getTotal();

                this.form.bill.push({
                    name: sample.id,
                    id: sample.id,
                    category: sample.sample_cert_type.billing_category,
                    type: sample.sample_cert_type.name,
                    info: "Lot: "+sample.lot + " | QA:" + sample.qa,
                    qty: 1,
                    rate: 0,
                    total: bill.totalCost,
                    package: null,
                    notes: sample.notes,
                    sample: sample,
                    bill :{
                        ...bill
                    }
                })
            },
            removeSampleFromBill(billItem){
                if(billItem.sample){
                    billItem.sample.added = false;
                }
                let findIndex = this.form.bill.findIndex(item => item.id === billItem.id)
                if(findIndex !== -1){
                  this.form.bill.splice(findIndex, 1)
                }
                if(this.form.bill.length === 0){
                    this.form.selectedCustomer = null;
                }
            },
            async getBillingInfo(){
                if(!this.$store.$db().model('imperatives').query().where('customer_id', this.form.selectedCustomer.customer_id).exists()){
                  await this.$store.$db().model('imperatives').api().fetch({
                    with: 'imperativeType',
                    where:{
                      key: "customer_id",
                      value: this.form.selectedCustomer.customer_id
                    }
                  })
                }
                if(!this.$store.$db().model('billings').query().where('customer_id', this.form.selectedCustomer.customer_id).exists()){
                  await this.$store.$db().model('billings').api().fetch({
                    where:{
                      key: "customer_id",
                      value: this.form.selectedCustomer.customer_id
                    }
                  })
                }
                // await this.$store.$db().model('billings').deleteAll();
            },
            async nextInvoiceNumber(){
              let mostRecentInvoice = await this.$firestore.collection('invoices').orderBy('invoice_id', 'desc').limit(1).get();
              if(mostRecentInvoice.docs.length > 0){
                let data = mostRecentInvoice.docs[0].data();
                return data.invoice_id + 1;
              }else{
                return 90000;
              }
            },
            async approveBilling(id){
              try{
                await this.$store.$db().model('samples').api().save({
                  id: id,
                  billing_approved: true,
                })
                this.$store.dispatch("showSuccess", 'Saved sample billing approved.')
              }catch{
                this.$store.dispatch("showError", 'Failed to mark sample as billing approved')
              }
            },
            async submitBill(){
                // return;
                if(!this.form.selectedCustomer){
                    this.$store.dispatch("showError", "Please select a customer first.");
                    return;
                }
                if(this.form.bill.some(bill => !bill.package)){
                    this.$store.dispatch("showError", "Some billing items are missing packages.");
                    return;
                }
                this.saving = true;
                let customer = this.$store.$db().model('customers').query().with('contract.contract_type').where('id', this.form.selectedCustomer.customer_id).first()
                let invoiceDate = this.$moment().format("MM/DD/YYYY");
                let dueDate = customer.contract.contract_type.desc === "NET 30" ? this.$moment(invoiceDate).add(30, 'days').format("MM/DD/YYYY") : invoiceDate;
                let invoice_id = await this.nextInvoiceNumber();
                let newInvoice = {
                    customer_id: this.form.selectedCustomer.customer_id,
                    invoice_id: invoice_id,
                    invoice_date: invoiceDate,
                    due_date: dueDate,
                    exported: false,
                    invoice_items: []
                }
                for(let i =0; i<this.form.bill.length; i+=1){
                    newInvoice.invoice_items.push({
                        invoice_id: invoice_id,
                        service: this.form.bill[i].package,
                        quantity: this.form.bill[i].qty,
                        rate: this.form.bill[i].total,
                        total: this.form.bill[i].total,
                        description: this.form.bill[i].info
                    });
                }
                await this.$firestore.collection("invoices").add(newInvoice)
                this.$store.dispatch('showSuccess', "Saved invoice!")
                this.form.bill = [];
                this.saving = false;
            }
        },
        beforeRouteLeave(from, to, next){
            this.$store.$db().model('customers').deleteAll();
            this.$store.$db().model('names').deleteAll();
            this.$store.$db().model('contacts').deleteAll();
            this.$store.$db().model('samples').deleteAll();
            this.$store.$db().model('sampleTests').deleteAll();
            this.$store.$db().model('sampleNotes').deleteAll();
            this.$store.$db().model('imperatives').deleteAll();
            next();
        },
    }
</script>

<style scoped>

</style>
